export const BSCSCAN_URL = "https://bscscan.com"

export const BACKEND_BASE_URL = "https://api.safelaunch.io"
